import React from "react";
import { BrowserRouter } from "react-router-dom";

const AppRouterProvider = ({ children }: { children: React.ReactNode }) => {
  return <BrowserRouter>{children}</BrowserRouter>;
};
export default AppRouterProvider;
